module.exports = __webpack_public_path__ + "a3a84c495fab5138826d563cf06b1934.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/toolbar/erase.svg
// module id = 30
// module chunks = 0